import Component from '../core/Component'
import CourseState from '../meta/CourseState'
import EventBus from '../core/EventBus'

export default class CourseList extends Component {
    constructor(element) {
        super(element)

        this.ref = {
            items: []
        }
    }

    prepare() {
        const { lessons } = CourseState.state
        const stateIds = Object.keys(lessons)

        const allIds = this.ref.items
            .map(element => element.dataset.id)

        const idsToAdd = allIds
            .filter(id => !(id in lessons))

        const idsToRemove = stateIds
            .filter(id => !allIds.includes(id))

        idsToAdd.forEach(id => CourseState.updateLesson({
            id,
            silent: true
        }))

        idsToRemove.forEach(id => CourseState.removeLesson({
            id,
            silent: true
        }))

        if (idsToAdd.length || idsToRemove.length) {
            CourseState.commit()
        }

        EventBus.on('modal:afteropen', this.handleModalOpen)
    }

    handleModalOpen = () => {
        const accordion = Component.getFromElement('course-list')

        if (accordion) {
            accordion.closeAll(true)
        }
    }

}